
// Change this value to switch environments in one place
//const BASE_URL = "http://localhost:8080";
const BASE_URL = "https://nodeserver.thevaultescrow.com";

export const API_URL = `${BASE_URL}/api/auth/`;
export const API_URL_TEST = `${BASE_URL}/api/test/`;
export const API_URL_IMAGE = BASE_URL;
export const CHAT_API_URL = `${BASE_URL}/api/chat/`;

